import TpCheckboxBase from './tp-checkbox-base.js';

class TpCheckbox extends TpCheckboxBase { }
export default TpCheckbox;